import { EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';

export class Loading {
  public static onChange = new Subject<boolean>();
  public static counter = 0;

  public static show() {
    this.counter++;
    Loading.onChange.next(true);
  }

  public static hide() {
    // if (this.counter > 0) {
    //   this.counter--;
    // }

    // if (this.counter === 0) {
      Loading.onChange.next(false);
    // }
  }

  public static error() {
    this.counter = 0;
    Loading.onChange.next(false);
  }

  public static hideAll() {
    this.counter = 0;
    Loading.onChange.next(false);
  }
}